<script lang="ts">
	import { Dialog as SheetPrimitive } from "bits-ui";
	import ModalRoot from "../modal/modal-root.svelte";

	let { open = $bindable(false), ...restProps }: SheetPrimitive.RootProps & { modalPriority?: number } = $props();
</script>

<ModalRoot bind:open {...restProps} />
